export class FormuleFormDto {
    id: number;
    name: string;
    description: string;
    system_form: number;
    updated_at: string;
    is_front: boolean;
    is_trigger: boolean;
}
